import React, { useState, useEffect } from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import Navigation from '../../../layout/Navigation/Navigation';
import { componentsMenu, layoutMenu } from '../../../menu';
import useDeviceScreen from '../../../hooks/useDeviceScreen';
import CommonHeaderRight from './CommonHeaderRight';

const DefaultHeader = () => {
	const deviceScreen = useDeviceScreen();
	const [selectedBranchName, setSelectedBranchName] = useState('');

	useEffect(() => {
		const updateBranchName = () => {
			const branchid = localStorage.getItem('selectedBranch');
			const branchesList = JSON.parse(localStorage.getItem('branches-list'));

			const selectedName = branchesList?.find(
				(branch) => String(branch.value) === String(branchid),
			)?.text;

			setSelectedBranchName(selectedName);
		};

		updateBranchName();

		const handleBranchChange = (e) => {
			if (e?.detail?.name) {
				setSelectedBranchName(e.detail.name);
			} else {
				updateBranchName();
			}
		};

		window.addEventListener('branchChanged', handleBranchChange);

		return () => {
			window.removeEventListener('branchChanged', handleBranchChange);
		};
	}, []);

	return (
		<Header>
			<HeaderLeft>
				{/* <Navigation
					menu={{ ...layoutMenu, ...componentsMenu }}
					id='header-top-menu'
					horizontal={deviceScreen?.width >= process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE}
				/> */}
				{selectedBranchName && (
					<span className='text-muted'>Branch: {selectedBranchName}</span>
				)}
			</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default DefaultHeader;
